// removed by extract-text-webpack-plugin
module.exports = {"skeleton":"styles__skeleton___3xcOm","skeleton-loading":"styles__skeleton-loading___RPLl4","itemTable":"styles__itemTable___1MH4V","table":"styles__table___38kmB","containerItem":"styles__containerItem___21qCh","input":"styles__input___19xAl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Skeleton/IncidentManagerSkeleton/styles.css
// module id = 806
// module chunks = 0